export function debounce<F extends (...params: Array<never>) => void> (fn: F, delay = 300): F {
    let timeoutId: number | null = null;

    return function bounce (this: never, ...args: Array<never>) {
        if (timeoutId !== null) clearTimeout(timeoutId);

        timeoutId = window.setTimeout(() => fn.apply(this, args), delay);
    } as F;
}
